import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-subscription-modal',
  templateUrl: './subscription-modal.component.html',
  styleUrls: ['./subscription-modal.component.scss']
})
export class SubscriptionModalComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<SubscriptionModalComponent>,
              @Inject(MAT_DIALOG_DATA) public data: { indicationAmount: number, notes: string }) {
  }

  ngOnInit(): void {
  }

}
